module.exports = __webpack_public_path__ + "img/126.4d3c6a6b.jpg";